import React, { Fragment, useState, useEffect } from 'react';
import { flattenTree } from 'react-accessible-treeview';
import CategoryTree from './CategoryTree';
import FilePanel from './FilePanel';
import { get } from '../../Services/http';

const MediaArchive = ({ model }) => {
    const [data, setData] = useState(model.filePanel);
    const [language, setLanguage] = useState(model.language);
    const [fileId, setFileId] = useState(model.fileId);
    const [flatTree, _] = useState(flattenTree(model.categoryTreeRoot));
    const [selectedCategoryName, setSelectedCategoryName] = useState(
        model.categoryId
            ? flatTree.find((n) => n.id === model.categoryId)?.name
            : ''
    );
    const findDescriptionById = (node, id) => {
        if (node.id === id) {
            return node.description;
        }
        if (node.children && node.children.length > 0) {
            for (let child of node.children) {
                const description = findDescriptionById(child, id);
                if (description) {
                    return description;
                }
            }
        }
        return '';
    };
    const [selectedCategoryDescription, setCategoryDescription] = useState(
        model.categoryId
            ? findDescriptionById(model.categoryTreeRoot, model.categoryId)
            : ''
    );
    const [selectedIds, setSelectedIds] = useState([model.categoryId]);
    const [expandedIds, setExpandedIds] = useState(model.defaultExpandedIds);
    const fetchFiles = async (page, categoryId, lang, fId) => {
        try {
            const fileIdPath = fId !== null ? `&fileId=${fId}` : '';
            history.pushState(
                { page, categoryId, language: lang, fileId: fId },
                '',
                `?page=${page}&categoryId=${categoryId}&language=${lang}${fileIdPath}`
            );
            const response = await get(
                `/api/mediaarchive/files?page=${page}&categoryId=${categoryId}&language=${lang}${fileIdPath}`
            );
            const files = await response.json();
            setData(files);
        } catch (ex) {
            console.log('error', ex);
        }
    };
    const handleLanguageChange = (e) => {
        setLanguage(e.target.value);
        fetchFiles(
            data.currentPage,
            !!selectedIds.length ? selectedIds[0] : null,
            e.target.value,
            fileId
        );
    };

    const getExpandedIds = (id) => {
        const newExpandedIds = [];

        let node = flatTree.find((n) => n.id === id);
        while (node) {
            if (node.children.length) {
                newExpandedIds.push(node.id);
            }
            node = flatTree.find((n) => n.id === node.parent);
        }
        return newExpandedIds;
    };
    useEffect(() => {
        if (data && model.categoryId) {
            const fileIdPath =
                model.fileId !== null ? `&fileId=${model.fileId}` : '';
            history.replaceState(
                {
                    page: data.currentPage,
                    categoryId: model.categoryId,
                    language: model.language,
                    fileId: model.fileId,
                },
                '',
                `?page=${data.currentPage}&categoryId=${model.categoryId}&language=${language}${fileIdPath}`
            );
        }
        window.addEventListener('popstate', (e) => {
            setSelectedIds([e.state.categoryId]);
            setFileId(e.state.fileId);
            setLanguage(e.state.language);
            fetchFiles(
                e.state.page,
                e.state.categoryId,
                e.state.language,
                e.state.fileId
            );
        });
    }, []);

    return (
        <Fragment>
            <div className="media-archive-wrapper">
                <div className="media-archive-header">
                    <div className="title">{model.title}</div>
                    <p className="first-paragraph">{model.firstParagraph}</p>
                    <p>{model.secondParagraph}</p>
                </div>
                <div className="media-content">
                    <CategoryTree
                        model={model}
                        selectedIds={selectedIds}
                        expandedIds={expandedIds}
                        onNodeSelect={(props) => {
                            setFileId(null);
                            setSelectedCategoryName(
                                props.isSelected ? props.element.name : ''
                            );
                            setSelectedIds(
                                props.isSelected ? [props.element.id] : null
                            );
                            setCategoryDescription(
                                props.isSelected
                                    ? findDescriptionById(
                                          model.categoryTreeRoot,
                                          props.element.id
                                      )
                                    : ''
                            );
                            props.isSelected &&
                                fetchFiles(1, props.element.id, language, null);
                            setExpandedIds(getExpandedIds(props.element.id));
                        }}
                    />
                    {data && (
                        <FilePanel
                            header={selectedCategoryName}
                            data={data}
                            description={selectedCategoryDescription}
                            languages={model.languages}
                            language={language}
                            fileId={fileId}
                            onRemoveFileId={() => {
                                setFileId(null);
                                fetchFiles(
                                    data?.currentPage ?? 1,
                                    selectedIds[0],
                                    language,
                                    null
                                );
                            }}
                            onPageChange={(page) => {
                                fetchFiles(
                                    page,
                                    selectedIds[0],
                                    language,
                                    null
                                );
                            }}
                            onLanguageChange={handleLanguageChange}
                        />
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default MediaArchive;
